import ThemeModeView from "app/WebView/Header/ThemeModeView"
import Logger from "logger/logger"
import React, {useEffect} from "react"
import EnvironmentService, {subscribeEnv} from "app/Service/System/EnvironmentService"

function ThemeModeSelector() {

  const {themeMode, toggleThemeMode} = EnvironmentService([
    subscribeEnv.themeMode
  ], 'ThemeModeSelector')

  useEffect(() => {
    Logger('Element.ThemeModeSelector.init')
    return () => {
      Logger('Element.ThemeModeSelector.unloading')
    }
  }, [])

  return undefined === themeMode ? null : (
    <ThemeModeView
      themeMode={themeMode}
      toggleThemeMode={toggleThemeMode}
    />
  )
}

export default ThemeModeSelector
